<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<form name="bufferForm" #bufferForm="ngForm" cdkTrapFocus>
    <div>
        <h1 mat-dialog-title>Create Buffer</h1>
        <div fxLayout="column" fxLayoutGap="12px">
            <div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="space-between center">
                <div *ngFor="let range of bufferRanges">
                    <button mat-raised-button type="button"
                            (click)="createBuffer(range, selectWithin)">{{ range }} ft</button>
                </div>
            </div>
            <mat-form-field>
                <input matInput
                       name="bufferDistance"
                       pattern="[0-9]+"
                       placeholder="Buffer Distance"
                       [(ngModel)]="bufferDistance" cdkFocusInitial />
            </mat-form-field>
            <mat-checkbox name="selectWithin"
                          [(ngModel)]="selectWithin">Select</mat-checkbox>
        </div>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button mat-button type="submit"
                [disabled]="bufferForm.value=='' || !bufferForm.valid"
                (click)="createBuffer(bufferDistance, selectWithin)">Create Buffer</button>
        <button mat-button (click)="onCancel()">Cancel</button>
    </div>
</form>
